import { StaticImageData } from 'next/image';
import type { CSSProperties } from 'react';

import CalmLogoGradient from '@/../public/_n/images/calm-logo-gradient.png';
import CalmLogoWhite from '@/../public/_n/images/calm-logo.png';
import Image from '@/components/image/NextImage';

import { BrandingWrapper, CoBrandedContainer, CoBrandedGroup, ImageContainer, LogoDivider } from './styles';

export type BrandingLogo = {
	white: StaticImageData | string;
	gradient: StaticImageData | string;
	alt: string;
	testId?: string;
};

const defaultLogo: BrandingLogo = {
	white: CalmLogoWhite,
	gradient: CalmLogoGradient,
	alt: 'Calm Logo',
	testId: 'branding-calm-logo',
};

type BrandingProps = {
	backgroundColor?: string;
	coBranded?: {
		src: StaticImageData | string;
		alt: string;
		style?: CSSProperties;
	};
	logo?: BrandingLogo;
};

const Branding = ({ backgroundColor, coBranded, logo = defaultLogo }: BrandingProps) => {
	const logoSrc = backgroundColor !== 'gray0' ? logo.white : logo.gradient;

	return (
		<BrandingWrapper>
			<ImageContainer>
				<Image alt={logo.alt} src={logoSrc} fill style={{ objectFit: 'contain' }} data-testid={logo.testId} />
			</ImageContainer>
			{coBranded && (
				<CoBrandedGroup>
					<LogoDivider />
					{typeof coBranded.src === 'string' ? (
						<CoBrandedContainer>
							<Image
								src={coBranded.src}
								alt={coBranded.alt}
								fill
								style={{
									objectFit: 'contain',
								}}
								data-testid="branding-cobranded-logo"
							/>
						</CoBrandedContainer>
					) : (
						<Image
							src={coBranded.src}
							alt={coBranded.alt}
							style={{ ...coBranded.style, objectPosition: 'bottom' }}
							data-testid="branding-cobranded-logo"
						/>
					)}
				</CoBrandedGroup>
			)}
		</BrandingWrapper>
	);
};

export default Branding;
